<template>
  <KinoModuleMain :legal-name />
</template>

<script lang="ts" setup>
const companyStore = useCompanyStore();
const legalName = computed(() => companyStore.company?.legalName ?? '');
</script>
